const baseButtonClasses =
  'flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2.5 min-h-[42px] w-full rounded-lg border text-[11px] font-semibold tracking-[0.12em] uppercase transition-all leading-none';

/**
 * PredictButton - Violet/gold terminal-style button matching homepage design
 * Bloomberg-style terminal appearance with confirmation state
 */
const PredictButton = ({
  label,
  isSelected = false,
  isLive = false,
  isFrozen = false,
  onClick
}) => {
  const stateClasses = isFrozen
    ? 'border-white/15 bg-white/5 text-white/50 opacity-60 cursor-not-allowed'
    : isSelected
    ? 'bg-[#FFD700]/20 border-[#FFD700]/50 text-[#FFD700] hover:bg-[#FFD700]/30'
    : isLive
    ? 'bg-emerald-500/20 border-emerald-400/40 text-emerald-50 hover:bg-emerald-500/30'
    : 'bg-violet-500/10 border-violet-500/30 text-violet-400 hover:bg-violet-500/20 hover:border-violet-500/50';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isFrozen}
      className={`${baseButtonClasses} ${stateClasses}`}
    >
      <span>{label}</span>
    </button>
  );
};

export default PredictButton;
